import React from "react";
import { useNavigate } from "react-router-dom";
import pakuKariyeData from "../../utils/pakuKariyeData";
import "./BalVibhag.css";
import { imageUrl } from "../../utils/imageUrl";   // ✅ FIXED IMPORT
import SectionDivider from "../../common/SectionDivider";

const BalVibhag = () => {
    const navigate = useNavigate();

    const handleCardClick = (item) => {
        if (item.route) {
            navigate(item.route);   // ✅ DIRECT ROUTE → CLEAN & BEST
        }
    };

    return (
        <div className="bal-vibhag-container">
            <SectionDivider title="ચાલો પાકુ કરીએ" />
            <div className="bal-vibhag-grid">
                {pakuKariyeData.map((item) => {
                    return (
                        <div
                            key={item.id}
                            className="bal-vibhag-card"
                            style={{
                                background: `linear-gradient(135deg, ${item.color1} 0%, ${item.color2} 100%)`,
                            }}
                            onClick={() => handleCardClick(item)}
                        >
                            <div className="bal-vibhag-card-content">

                                {item.icon ? (
                                    <div className="bal-vibhag-card-image-wrapper">
                                        <img
                                            src={imageUrl(item.icon)}   // ✅ MAIN FIX
                                            alt={item.title}
                                            className="bal-vibhag-card-image"
                                            onError={(e) => {
                                                e.target.style.display = "none";
                                            }}
                                        />
                                    </div>
                                ) : (
                                    <div className="bal-vibhag-card-image-wrapper">
                                        <div className="bal-vibhag-card-image-placeholder">📚</div>
                                    </div>
                                )}

                                <h3 className="bal-vibhag-card-title">{item.title}</h3>
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default BalVibhag;
